import status from '../components/operation/enums/chatRoomStatus'

let storageName = 'new-message-flag-v2'

const getStorageName = () => {
  return storageName
}

const setNewChatMessageFlag = () => {
  const defaultStatus = {
    assign: [],
    active: [],
    transfer: []
  }

  localStorage.setItem(storageName, JSON.stringify(defaultStatus))
}

function parseFlagOptionIntoJson (type, newData, json) {
  let result = {}
  if (type === status.ASSIGN) {
    result = {
      assign: newData,
      active: json.active,
      transfer: json.transfer
    }
  } else if (type === status.ACTIVE) {
    result = {
      assign: json.assign,
      active: newData,
      transfer: json.transfer
    }
  } else if (type === status.TRANSFER) {
    result = {
      assign: json.assign,
      active: json.active,
      transfer: newData
    }
  }

  localStorage.setItem(storageName, JSON.stringify(result))
  return JSON.stringify(result)
}

function removeNewFlagChatRoom (chatRoomId) {
  const option = JSON.parse(localStorage.getItem(storageName))

  const assignIdx = option[status.ASSIGN] ? option[status.ASSIGN].indexOf(chatRoomId) : -1
  const activeIdx = option[status.ACTIVE] ? option[status.ACTIVE].indexOf(chatRoomId) : -1
  const transIdx = option[status.TRANSFER] ? option[status.TRANSFER].indexOf(chatRoomId) : -1

  if (assignIdx > -1) {
    option[status.ASSIGN].splice(assignIdx, 1)
    this.parseFlagOptionIntoJson(status.ASSIGN, option[status.ASSIGN], option)
  }
  if (activeIdx > -1) {
    option[status.ACTIVE].splice(activeIdx, 1)
    this.parseFlagOptionIntoJson(status.ACTIVE, option[status.ACTIVE], option)
  }
  if (transIdx > -1) {
    option[status.TRANSFER].splice(transIdx, 1)
    this.parseFlagOptionIntoJson(status.TRANSFER, option[status.TRANSFER], option)
  }
}

// 전체탭-대기, 전체탭-할당(본인 것에 한하여) 중이거나 할당탭 에서 보는 경우 [상담 시작하기] 버튼 노출
const showPickButton = (status, displayingChatRoomStatus, distributionOption, isPickAvailable) => {
  let waitingCondition
  if (distributionOption && distributionOption === 'SEQUENTIALLY_ASSIGNMENT') {
    // 자동배분 - 상담순차별 일 경우, '대기' 인 방에 대해서는 [상담 시작하기]를 제공하지 않는다.
    waitingCondition = false
  } else {
    // 그 외 일반적인 상황.
    waitingCondition = (status === 'ALL' && displayingChatRoomStatus === 'WAITING')
  }
  let assignCondition = (status === 'ASSIGN') || (status === 'ALL' && displayingChatRoomStatus === 'ASSIGN' && isPickAvailable)
  return waitingCondition || assignCondition
}

export default {
  getStorageName,
  setNewChatMessageFlag,
  parseFlagOptionIntoJson,
  removeNewFlagChatRoom,
  showPickButton
}



// WEBPACK FOOTER //
// ./src/util/chatroom.js